import querystring from 'query-string';
import { SHOP_DELIVERY_TYPE } from '@shared/constants';
import { format } from '@utils/string';
import {
  getShopMenuURLWithNiles,
  getShopMenuURL,
} from '@services/urls/apiGatewayURLs';
import ServiceResponse from '../models/ServiceResponse';
import { mapperV2 } from './niles';

const message = 'shopId param is required';

const API_VERSION = {
  NILES: { url: getShopMenuURLWithNiles, applyMapper: true },
  MOBILE_SERVICES: { url: getShopMenuURL, applyMapper: false },
};

async function getShopMenu({
  axios,
  shopId,
  search,
  category,
  occasion = SHOP_DELIVERY_TYPE.DELIVERY,
}) {
  try {
    if (!shopId) return new ServiceResponse({ error: message });

    const params = {};

    if (search) params.value = search;
    if (category) params.categories = category;

    params.occasion = occasion;

    const query = querystring.stringify(params);

    const { url, applyMapper } = API_VERSION.NILES;

    const shopInfoUrl = format(url, shopId, query);

    const { data } = await axios.get(shopInfoUrl);

    return new ServiceResponse({
      data: applyMapper && data ? mapperV2(data) : data,
    });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default getShopMenu;
